function sortByKey<TElement>(key: keyof TElement) {
    return (a: TElement, b: TElement) => {
        const tempA = a[key];
        const tempB = b[key];

        const valueA = typeof tempA === 'string' ? tempA.toLowerCase() : tempA;
        const valueB = typeof tempB === 'string' ? tempB.toLowerCase() : tempB;
        if (valueA < valueB) {
            return -1;
        }
        if (valueA > valueB) {
            return 1;
        }

        return 0;
    };
}

export default sortByKey;
